/**
 * @generated SignedSource<<dcba349dc7c8d2b6750394625077685e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingHolidayDelivery_sku" | "PdpSharedShippingInfoWrapper_sku">;
  readonly " $fragmentType": "PdpRespSidebarBlurbShipping_sku";
};
export type PdpRespSidebarBlurbShipping_sku$key = {
  readonly " $data"?: PdpRespSidebarBlurbShipping_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_sku",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingHolidayDelivery_sku"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoWrapper_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "a35d10e20ec79261578e8a262a22b13b";

export default node;
